import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _ba4bbc32 = () => interopDefault(import('../../../pages/access-tokens/index.vue' /* webpackChunkName: "pages/access-tokens/index" */))
const _6fef3646 = () => interopDefault(import('../../../pages/client/index.vue' /* webpackChunkName: "pages/client/index" */))
const _4bdac909 = () => interopDefault(import('../../../pages/forgot-password/index.vue' /* webpackChunkName: "pages/forgot-password/index" */))
const _5ce42cac = () => interopDefault(import('../../../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _ccb5c6a6 = () => interopDefault(import('../../../pages/profile/index.vue' /* webpackChunkName: "pages/profile/index" */))
const _47d37677 = () => interopDefault(import('../../../pages/public-test.vue' /* webpackChunkName: "pages/public-test" */))
const _6048521c = () => interopDefault(import('../../../pages/register.vue' /* webpackChunkName: "pages/register" */))
const _8aeec7fe = () => interopDefault(import('../../../pages/super-admin/index.vue' /* webpackChunkName: "pages/super-admin/index" */))
const _374b2862 = () => interopDefault(import('../../../pages/client/matched-items.vue' /* webpackChunkName: "pages/client/matched-items" */))
const _65374302 = () => interopDefault(import('../../../pages/client/mn-profile.vue' /* webpackChunkName: "pages/client/mn-profile" */))
const _3e0a9d18 = () => interopDefault(import('../../../pages/client/profile.vue' /* webpackChunkName: "pages/client/profile" */))
const _766ef135 = () => interopDefault(import('../../../pages/super-admin/analytics.vue' /* webpackChunkName: "pages/super-admin/analytics" */))
const _ca6ce262 = () => interopDefault(import('../../../pages/super-admin/organizations.vue' /* webpackChunkName: "pages/super-admin/organizations" */))
const _208e7ed6 = () => interopDefault(import('../../../pages/super-admin/plan-calculator.vue' /* webpackChunkName: "pages/super-admin/plan-calculator" */))
const _19f6144a = () => interopDefault(import('../../../pages/super-admin/question-sets/index.vue' /* webpackChunkName: "pages/super-admin/question-sets/index" */))
const _2e733044 = () => interopDefault(import('../../../pages/super-admin/settings.vue' /* webpackChunkName: "pages/super-admin/settings" */))
const _64f32774 = () => interopDefault(import('../../../pages/super-admin/translations/index.vue' /* webpackChunkName: "pages/super-admin/translations/index" */))
const _001b1392 = () => interopDefault(import('../../../pages/super-admin/users.vue' /* webpackChunkName: "pages/super-admin/users" */))
const _42a8532e = () => interopDefault(import('../../../pages/super-admin/community-database/careers/index.vue' /* webpackChunkName: "pages/super-admin/community-database/careers/index" */))
const _4aa3fc38 = () => interopDefault(import('../../../pages/super-admin/community-database/hobbies/index.vue' /* webpackChunkName: "pages/super-admin/community-database/hobbies/index" */))
const _7ee9d042 = () => interopDefault(import('../../../pages/super-admin/community-database/tasks/index.vue' /* webpackChunkName: "pages/super-admin/community-database/tasks/index" */))
const _1e834175 = () => interopDefault(import('../../../pages/super-admin/community-database/careers/create.vue' /* webpackChunkName: "pages/super-admin/community-database/careers/create" */))
const _ba72f54c = () => interopDefault(import('../../../pages/super-admin/community-database/hobbies/create.vue' /* webpackChunkName: "pages/super-admin/community-database/hobbies/create" */))
const _f3f6fa88 = () => interopDefault(import('../../../pages/super-admin/community-database/tasks/create.vue' /* webpackChunkName: "pages/super-admin/community-database/tasks/create" */))
const _551cd658 = () => interopDefault(import('../../../pages/super-admin/community-database/careers/_id/index.vue' /* webpackChunkName: "pages/super-admin/community-database/careers/_id/index" */))
const _652b8acf = () => interopDefault(import('../../../pages/super-admin/community-database/hobbies/_id/index.vue' /* webpackChunkName: "pages/super-admin/community-database/hobbies/_id/index" */))
const _60060ba6 = () => interopDefault(import('../../../pages/super-admin/community-database/tasks/_id/index.vue' /* webpackChunkName: "pages/super-admin/community-database/tasks/_id/index" */))
const _433bad16 = () => interopDefault(import('../../../pages/super-admin/community-database/careers/_id/history.vue' /* webpackChunkName: "pages/super-admin/community-database/careers/_id/history" */))
const _675fdf5e = () => interopDefault(import('../../../pages/super-admin/community-database/hobbies/_id/history.vue' /* webpackChunkName: "pages/super-admin/community-database/hobbies/_id/history" */))
const _6ef9bfa2 = () => interopDefault(import('../../../pages/super-admin/community-database/tasks/_id/history.vue' /* webpackChunkName: "pages/super-admin/community-database/tasks/_id/history" */))
const _13b0a132 = () => interopDefault(import('../../../pages/super-admin/question-sets/_id.vue' /* webpackChunkName: "pages/super-admin/question-sets/_id" */))
const _25ff2651 = () => interopDefault(import('../../../pages/super-admin/translations/_category.vue' /* webpackChunkName: "pages/super-admin/translations/_category" */))
const _9574205a = () => interopDefault(import('../../../pages/forgot-password/_token.vue' /* webpackChunkName: "pages/forgot-password/_token" */))
const _5034c104 = () => interopDefault(import('../../../pages/live-assessment/_secret.vue' /* webpackChunkName: "pages/live-assessment/_secret" */))
const _400fabe2 = () => interopDefault(import('../../../pages/organizations/_id/index.vue' /* webpackChunkName: "pages/organizations/_id/index" */))
const _2802eb22 = () => interopDefault(import('../../../pages/tests/_secret.vue' /* webpackChunkName: "pages/tests/_secret" */))
const _1e2cc843 = () => interopDefault(import('../../../pages/organizations/_id/analytics.vue' /* webpackChunkName: "pages/organizations/_id/analytics" */))
const _6fabfe7b = () => interopDefault(import('../../../pages/organizations/_id/billing/index.vue' /* webpackChunkName: "pages/organizations/_id/billing/index" */))
const _c8d7561c = () => interopDefault(import('../../../pages/organizations/_id/integrations.vue' /* webpackChunkName: "pages/organizations/_id/integrations" */))
const _1aeda246 = () => interopDefault(import('../../../pages/organizations/_id/organizations.vue' /* webpackChunkName: "pages/organizations/_id/organizations" */))
const _809f2d54 = () => interopDefault(import('../../../pages/organizations/_id/practitioners.vue' /* webpackChunkName: "pages/organizations/_id/practitioners" */))
const _c1918114 = () => interopDefault(import('../../../pages/organizations/_id/settings.vue' /* webpackChunkName: "pages/organizations/_id/settings" */))
const _25620445 = () => interopDefault(import('../../../pages/organizations/_id/users.vue' /* webpackChunkName: "pages/organizations/_id/users" */))
const _1e2b2413 = () => interopDefault(import('../../../pages/organizations/_id/billing/plans.vue' /* webpackChunkName: "pages/organizations/_id/billing/plans" */))
const _58d17616 = () => interopDefault(import('../../../pages/organizations/_id/clients/group.vue' /* webpackChunkName: "pages/organizations/_id/clients/group" */))
const _09828d8e = () => interopDefault(import('../../../pages/organizations/_id/clients/one-on-one.vue' /* webpackChunkName: "pages/organizations/_id/clients/one-on-one" */))
const _2b5c58d9 = () => interopDefault(import('../../../pages/organizations/_id/overview/licensee-admin.vue' /* webpackChunkName: "pages/organizations/_id/overview/licensee-admin" */))
const _587b57a6 = () => interopDefault(import('../../../pages/organizations/_id/overview/practitioner.vue' /* webpackChunkName: "pages/organizations/_id/overview/practitioner" */))
const _a25692a2 = () => interopDefault(import('../../../pages/organizations/_id/overview/practitioner-admin.vue' /* webpackChunkName: "pages/organizations/_id/overview/practitioner-admin" */))
const _27933d34 = () => interopDefault(import('../../../pages/organizations/_id/tests/_test/live-assessment.vue' /* webpackChunkName: "pages/organizations/_id/tests/_test/live-assessment" */))
const _a3a0b05a = () => interopDefault(import('../../../pages/organizations/_id/tests/_test/report.vue' /* webpackChunkName: "pages/organizations/_id/tests/_test/report" */))
const _0fd5c10e = () => interopDefault(import('../../../pages/organizations/_id/tests/_test/report/careers.vue' /* webpackChunkName: "pages/organizations/_id/tests/_test/report/careers" */))
const _7e104334 = () => interopDefault(import('../../../pages/organizations/_id/tests/_test/report/hobbies.vue' /* webpackChunkName: "pages/organizations/_id/tests/_test/report/hobbies" */))
const _343d266d = () => interopDefault(import('../../../pages/organizations/_id/tests/_test/report/profile.vue' /* webpackChunkName: "pages/organizations/_id/tests/_test/report/profile" */))
const _291b58d2 = () => interopDefault(import('../../../pages/organizations/_id/tests/_test/report/tasks.vue' /* webpackChunkName: "pages/organizations/_id/tests/_test/report/tasks" */))
const _07e64693 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/access-tokens",
    component: _ba4bbc32,
    name: "access-tokens"
  }, {
    path: "/client",
    component: _6fef3646,
    name: "client"
  }, {
    path: "/forgot-password",
    component: _4bdac909,
    name: "forgot-password"
  }, {
    path: "/login",
    component: _5ce42cac,
    name: "login"
  }, {
    path: "/profile",
    component: _ccb5c6a6,
    name: "profile"
  }, {
    path: "/public-test",
    component: _47d37677,
    name: "public-test"
  }, {
    path: "/register",
    component: _6048521c,
    name: "register"
  }, {
    path: "/super-admin",
    component: _8aeec7fe,
    name: "super-admin"
  }, {
    path: "/client/:type(hobbies|tasks|careers)/",
    component: _374b2862,
    name: "client-matched-items"
  }, {
    path: "/client/mn-profile",
    component: _65374302,
    name: "client-mn-profile"
  }, {
    path: "/client/profile",
    component: _3e0a9d18,
    name: "client-profile"
  }, {
    path: "/super-admin/analytics",
    component: _766ef135,
    name: "super-admin-analytics"
  }, {
    path: "/super-admin/organizations",
    component: _ca6ce262,
    name: "super-admin-organizations"
  }, {
    path: "/super-admin/plan-calculator",
    component: _208e7ed6,
    name: "super-admin-plan-calculator"
  }, {
    path: "/super-admin/question-sets",
    component: _19f6144a,
    name: "super-admin-question-sets"
  }, {
    path: "/super-admin/settings",
    component: _2e733044,
    name: "super-admin-settings"
  }, {
    path: "/super-admin/translations",
    component: _64f32774,
    name: "super-admin-translations"
  }, {
    path: "/super-admin/users",
    component: _001b1392,
    name: "super-admin-users"
  }, {
    path: "/super-admin/community-database/careers",
    component: _42a8532e,
    name: "super-admin-community-database-careers"
  }, {
    path: "/super-admin/community-database/hobbies",
    component: _4aa3fc38,
    name: "super-admin-community-database-hobbies"
  }, {
    path: "/super-admin/community-database/tasks",
    component: _7ee9d042,
    name: "super-admin-community-database-tasks"
  }, {
    path: "/super-admin/community-database/careers/create",
    component: _1e834175,
    name: "super-admin-community-database-careers-create"
  }, {
    path: "/super-admin/community-database/hobbies/create",
    component: _ba72f54c,
    name: "super-admin-community-database-hobbies-create"
  }, {
    path: "/super-admin/community-database/tasks/create",
    component: _f3f6fa88,
    name: "super-admin-community-database-tasks-create"
  }, {
    path: "/super-admin/community-database/careers/:id",
    component: _551cd658,
    name: "super-admin-community-database-careers-id"
  }, {
    path: "/super-admin/community-database/hobbies/:id",
    component: _652b8acf,
    name: "super-admin-community-database-hobbies-id"
  }, {
    path: "/super-admin/community-database/tasks/:id",
    component: _60060ba6,
    name: "super-admin-community-database-tasks-id"
  }, {
    path: "/super-admin/community-database/careers/:id?/history",
    component: _433bad16,
    name: "super-admin-community-database-careers-id-history"
  }, {
    path: "/super-admin/community-database/hobbies/:id?/history",
    component: _675fdf5e,
    name: "super-admin-community-database-hobbies-id-history"
  }, {
    path: "/super-admin/community-database/tasks/:id?/history",
    component: _6ef9bfa2,
    name: "super-admin-community-database-tasks-id-history"
  }, {
    path: "/super-admin/question-sets/:id",
    component: _13b0a132,
    name: "super-admin-question-sets-id"
  }, {
    path: "/super-admin/translations/:category",
    component: _25ff2651,
    name: "super-admin-translations-category"
  }, {
    path: "/forgot-password/:token?",
    component: _9574205a,
    name: "forgot-password-token"
  }, {
    path: "/live-assessment/:secret?",
    component: _5034c104,
    name: "live-assessment-secret"
  }, {
    path: "/organizations/:id/:overview(overview)?/",
    component: _400fabe2,
    name: "organizations-id"
  }, {
    path: "/tests/:secret?",
    component: _2802eb22,
    name: "tests-secret"
  }, {
    path: "/organizations/:id?/analytics",
    component: _1e2cc843,
    name: "organizations-id-analytics"
  }, {
    path: "/organizations/:id?/billing",
    component: _6fabfe7b,
    name: "organizations-id-billing"
  }, {
    path: "/organizations/:id?/integrations",
    component: _c8d7561c,
    name: "organizations-id-integrations"
  }, {
    path: "/organizations/:id?/organizations",
    component: _1aeda246,
    name: "organizations-id-organizations"
  }, {
    path: "/organizations/:id?/practitioners",
    component: _809f2d54,
    name: "organizations-id-practitioners"
  }, {
    path: "/organizations/:id?/settings",
    component: _c1918114,
    name: "organizations-id-settings"
  }, {
    path: "/organizations/:id?/users",
    component: _25620445,
    name: "organizations-id-users"
  }, {
    path: "/organizations/:id?/billing/plans",
    component: _1e2b2413,
    name: "organizations-id-billing-plans"
  }, {
    path: "/organizations/:id/clients/:type(group|mnlife)/",
    component: _58d17616,
    name: "organizations-id-clients-group"
  }, {
    path: "/organizations/:id/clients/:type(one-on-one|all)/",
    component: _09828d8e,
    name: "organizations-id-clients-one-on-one"
  }, {
    path: "/organizations/:id?/overview/licensee-admin",
    component: _2b5c58d9,
    name: "organizations-id-overview-licensee-admin"
  }, {
    path: "/organizations/:id?/overview/practitioner",
    component: _587b57a6,
    name: "organizations-id-overview-practitioner"
  }, {
    path: "/organizations/:id?/overview/practitioner-admin",
    component: _a25692a2,
    name: "organizations-id-overview-practitioner-admin"
  }, {
    path: "/organizations/:id?/tests/:test?/live-assessment",
    component: _27933d34,
    name: "organizations-id-tests-test-live-assessment"
  }, {
    path: "/organizations/:id?/tests/:test?/report",
    component: _a3a0b05a,
    name: "organizations-id-tests-test-report",
    children: [{
      path: "/organizations/:id/tests/:test/report/careers/:cluster?",
      component: _0fd5c10e,
      name: "organizations-id-tests-test-report-careers"
    }, {
      path: "/organizations/:id/tests/:test/report/hobbies/:cluster?",
      component: _7e104334,
      name: "organizations-id-tests-test-report-hobbies"
    }, {
      path: "profile",
      component: _343d266d,
      name: "organizations-id-tests-test-report-profile"
    }, {
      path: "/organizations/:id/tests/:test/report/tasks/:cluster?",
      component: _291b58d2,
      name: "organizations-id-tests-test-report-tasks"
    }]
  }, {
    path: "/",
    component: _07e64693,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
